
import {
  performance,
} from "plugins/user-timing-polyfill"

import {
  Metric,
  // Unless we want to create a plugin here, import the type only
  Plugin,
} from "@figliolia/metrics"

/**
 * Different from the one from `@figliolia/metrics`
 * This plugin uses polyfill and use `performance.mark` instead of less accurate time values
 */
export class SpaciousSimplePerformanceMeasurePlugin<T extends Metric<any, any>> extends Plugin<T> {
  protected override start(metric: T) {
    performance.mark(`${metric.name}_start`)
  }
  protected override stop(metric: T) {
    performance.mark(`${metric.name}_stop`)
    performance.measure(metric.name, `${metric.name}_start`, `${metric.name}_stop`)
  }
}

function createSimplePerformanceMetric(metric_name: string, options: Record<string, Plugin> = {}) {
  return new Metric(metric_name, {
    measure: new SpaciousSimplePerformanceMeasurePlugin(),
    ...options,
  })
}

export class SimplePerformanceMetric {
  private metric_entry

  constructor(metric_name: string) {
    this.metric_entry = createSimplePerformanceMetric(metric_name)
  }

  public measure<T>(func_to_be_executed: (() => T)) {
    this.metric_entry.start()
    const result = func_to_be_executed()
    this.metric_entry.stop()
    return result
  }

  public async measureAsync<T>(func_to_be_executed: (() => Promise<T>)) {
    this.metric_entry.start()
    const result = await func_to_be_executed()
    this.metric_entry.stop()
    return result
  }
}


